import Hls, {FragmentLoaderContext, HlsConfig, LoaderContext, M3U8Parser, PlaylistLevelType} from "hls.js";
import apiClient from "../../lib/api.ts";
import {pathFromAssetURL, isAssetURLExpired} from "../assets.ts";

const isFragmentContext = (context: LoaderContext): context is FragmentLoaderContext => "frag" in context

const expiryLeeway = 10 // seconds
const resignedFragments = new Map<string, string>();

class Loader extends Hls.DefaultConfig.loader {

    constructor(config: HlsConfig) {
        super(config);
        const load = this.load.bind(this);
        this.load = async (context, config, callbacks) => {
            if (isFragmentContext(context)) {
                context.url = await this._getValidFragmentURL(context)
            }
            return load(context, config, callbacks);
        };
    }

    async _getValidFragmentURL(context: FragmentLoaderContext): Promise<string> {
        if (!isAssetURLExpired(context.url, expiryLeeway)) {
            return context.url
        }
        return this._getResignedFragmentURL(context)
    }

    async _getResignedFragmentURL(context: FragmentLoaderContext): Promise<string> {
        const path = pathFromAssetURL(context.url)
        let resignedURL = resignedFragments.get(path)
        if (resignedURL && !isAssetURLExpired(resignedURL, expiryLeeway)) {
            return resignedURL
        }
        (await this._resignFragments(context.frag.base.url)).forEach((val: string, key: string) => {
            resignedFragments.set(key, val)
        })
        resignedURL = resignedFragments.get(path)
        if (!resignedURL) {
            throw `expected path ${path} to be in the resigned fragments for asset URL ${context.frag.base.url}`
        }
        return resignedURL
    }

    async _resignFragments(baseURL: string): Promise<Map<string, string>> {
        const output = await apiClient.resignFile(baseURL)
        const resp  = await fetch(output.assetURL)
        const m3u8 = await resp.text()

        // @ts-expect-error because of PlaylistLevelType
        const playlist = M3U8Parser.parseLevelPlaylist(m3u8, baseURL, 0, PlaylistLevelType.MAIN, 0, null)
        return new Map(playlist.fragments.map(fragment => [pathFromAssetURL(fragment.url), fragment.url]))
    }
}

export default Loader
